import { createSlice } from "@reduxjs/toolkit";

const nameSlice = createSlice({
  name: "Product",
  initialState: {
    priceHeadline: 
      {colorOne: "#fff",
      titleOne: "BILLING NOTICE",
      colorTwo: "#b5b5b3",
      titleTwo: "ALL COMPUTE TIME IS BILLED BY THE MINUTE.",
      colorThree: "#b5b5b3",
      titleThree: "NO HIDDEN FEES. PAUSE ANYTIME.",
    },
    priceHeadlineTwo :
      {
      colorOne: "#fff",
      titleOne: "SCALE EFFICIENTLY WITH OUR",
      colorTwo: "#b5b5b3",
      titleTwo: "MULTI-NODE ON-DEMAND",
      colorThree: "#b5b5b3",
      titleThree: "INSTANCES",
    }
  ,
  TypesHeadline :{
      colorOne: "#fff",
      titleOne: "CPU",
      colorTwo: "#b5b5b3",
      titleTwo: "INSTANCE TYPES",
    },
    StorageHeadline : {
      colorOne: "#020817",
      titleOne: "STORAGE TYPES",
      colorTwo: "#b5b5b3",
      titleTwo: "FOR MOST DEMANDING NEEDS",
    },
    PremiumHeadline :{
      colorOne: "#020817",
      titleOne: "PREMIUM NETWORK SERVICES",
      colorTwo: "#b5b5b3",
      titleTwo: "FOR SPEED AND SCALABILITYS",
    },
    AdditionalHeadline:{
      colorOne: "#020817",
      titleOne: "ADDITIONAL",
      colorTwo: "#b5b5b3",
      titleTwo: "FEATURES",
    },
    ContactHeadline :{
      colorOne: "#020817",
      titleOne: "ALL PLANS INCLUDE 24/7 MONITORING,",
      colorTwo: "#b5b5b3",
      titleTwo: "REDUNDANT POWER, AND TIER 3+ UPTIME.",
    },
    AttributeList :[
      {
        title: "Compute Rental Solutions",
        content:
          "We provide flexible access to high-performance computing infrastructure — including GPU and CPU servers — to support AI, blockchain, and scientific workloads.",
      },
      {
        title: "Scalable for Any Workload ",
        content:
          "From small-scale testing to enterprise-level deployment, our solutions grow with your needs.",
      },
      {
        title: "Energy-Efficient Infrastructure",
        content:
          "Our systems are housed in energy-optimized environments, ensuring sustainability without compromising performance.",
      },

    ],
    
    PriceList :[
      {
        version: "NVIDIA HGX™ H100",
        detailsOne: [
          "Data center locations: Norway, France, Spain, Finland, USA, Canada.",
        ],
        detailsTwo: [
          "Example of a node configuration:",
          "- 8x NVIDIA H100 GPU 80 GB",
          "- 2x 4th Gen Intel® Xeon® 8480+ CPUs",
          "- 2 TB DDR5 System RAM",
          "- 3.2 Tbps InfiniBand Networking",
          "- 4x 7.68 TB NVMe SSD (30.72 TB in total)",
          "- 200 Gbps Ethernet Networking",
        ],
        detailsThree: ["Configurations vary depending on location."],
        price: "1.80/h",
      },
      {
        version: "NVIDIA HGX™ H200",
        detailsOne: ["Data center locations: France, Spain, Finland, USA, Canada."],
        detailsTwo: [
          "Example of a node configuration:",
          "- 8x NVIDIA H200 GPU 141 GB",
          "- 2x 4th Gen Intel® Xeon® 8480+ CPUs",
          "- 2 TB DDR5 System RAM",
          "- 3.2 Tbps InfiniBand Networking",
          "- 4x 7.68 TB NVMe SSD (30.72 TB in total)",
          "- 200 Gbps Ethernet Networking",
        ],
        detailsThree: ["Configurations vary depending on location."],
        price: "2.45/h",
      },
      {
        version: "NVIDIA HGX™ B200",
        detailsOne: ["Data center location: Norway."],
        detailsTwo: [
          "Node configuration including 8x NVIDIA B200 GPU 180 GB, 3.2 Tbps InfiniBand Networking, and 200 Gbps Ethernet Networking.",
        ],
        detailsThree: [""],
        price: "3.75/h",
      },
      {
        version: "NVIDIA GB200 NVL72",
        detailsOne: ["Available soon. Request for quote"],
        detailsTwo: [""],
        detailsThree: [""],
        price: "RFQ",
      },
      {
        version: "NVIDIA® GeForce™ RTX 3080",
        detailsOne: ["Data center locations: Norway"],
        detailsTwo: [
          "4 vCPUs, 24GB VRAM, 24GB System RAM, 120GB System Disk (expandable)",
        ],
        detailsThree: [
          "Also available - CPU & Memory Optimized: 8 vCPUs, 24GB VRAM, 48GB System RAM120GB System Disk (expandable)",
        ],
        price: "0.20/h",
      },
      {
        version: "NVIDIA® GeForce™ RTX 3090",
        detailsOne: ["Data center locations: Norway"],
        detailsTwo: [
          "4 vCPUs, 10GB VRAM, 16GB System RAM, 120GB System Disk (expandable)",
        ],
        detailsThree: [
          "Also available - CPU & Memory Optimized: 8 vCPUs, 10GB VRAM, 32GB System RAM, 120GB System Disk (expandable)",
        ],
        price: "0.30/h",
      },
    ],
    PriceListTwo :[
      {
        version: "NVIDIA HGX™ H100",
        detailsOne: [
          "Data center locations: Norway, France, Spain, Finland, USA, Canada.",
        ],
        detailsTwo: [
          "Example of a node configuration:",
          "- 8x NVIDIA H100 GPU 80 GB",
          "- 2x 4th Gen Intel® Xeon® 8480+ CPUs",
          "- 2 TB DDR5 System RAM",
          "- 3.2 Tbps InfiniBand Networking",
          "- 4x 7.68 TB NVMe SSD (30.72 TB in total)",
          "- 200 Gbps Ethernet Networking",
        ],
        detailsThree: ["Configurations vary depending on location."],
        price: "2.99/h",
      },
      {
        version: "NVIDIA HGX™ B200",
        detailsOne: ["Data center location: Norway."],
        detailsTwo: [
          "Node configuration including 8x NVIDIA B200 GPU 180 GB, 3.2 Tbps InfiniBand Networking, and 200 Gbps Ethernet Networking.",
        ],
        detailsThree: [""],
        price: "4.99/h",
      },
    ],
    TypesList :[
      {
        content: [
          {
            name: "AMD EPYC 7552",
            cpu: "2 vCPU",
            memory: "4 GiB",
            disk: "80 GiB",
            price: "$0.10",
          },
          {
            name: "AMD EPYC 7552",
            cpu: "4 vCPU",
            memory: "8 GiB",
            disk: "80 GiB",
            price: "$0.20",
          },
          {
            name: "AMD EPYC 7552",
            cpu: "8 vCPU",
            memory: "16 GiB",
            disk: "80 GiB",
            price: "$0.40",
          },
          {
            name: "AMD EPYC 7552",
            cpu: "12 vCPU",
            memory: "24 GiB",
            disk: "80 GiB",
            price: "$0.60",
          },
          {
            name: "AMD EPYC 7552",
            cpu: "16 vCPU",
            memory: "32 GiB",
            disk: "80 GiB",
            price: "$0.80",
          },
          {
            name: "AMD EPYC 7552",
            cpu: "20 vCPU",
            memory: "40 GiB",
            disk: "80 GiB",
            price: "$1.00",
          },
          {
            name: "AMD EPYC 7552",
            cpu: "24 vCPU",
            memory: "48 GiB",
            disk: "80 GiB",
            price: "$1.20",
          },
        ],
      },
    ],
    StorageList : [
      {
        name: "Block Storage",
        price: "0.04",
        details: [
          "Optimized for high throughput and low latency",
          "Reliable and persistent storage",
          "Available in SSD or HDD (pricing varies)",
          "Perfect for long-term storage and data reuse",
        ],
      },
      {
        name: "High-Performance File Storage",
        price: "0.10",
        details: [
          "Ultra-fast performance",
          "Scalable and adaptable without limits",
          "AI-driven data platform powered by VAST Data",
          "Perfect for large-scale multi-node AI model training",
        ],
      },
      {
        name: "Object Storage",
        price: "0.03",
        details: [
          "Fully S3-compatible",
          "Highly elastic and scalable",
          "Ideal for ML datasets and backup storage",
        ],
      },
      {
        name: "Local Storage",
        price: "Pricing varies based on configuration",
        details: [
          "High performance with low latency and high IOPS",
          "Excellent availability",
          "Perfect for applications requiring fast, reliable data access",
        ],
      },
      {
        name: "Disk Snapshots",
        price: "0.02",
        details: [
          "Efficient and fast backup solution",
          "Point-in-time backups for data recovery",
          "Ideal for quick versioning and backup purposes",
        ],
      },
    ],
    PremiumList :[
      {
        name: "Public Internet Connectivity",
        price: "",
        details: [
          "Multi Gbps, redundant and resilient",
          "IPv4 (paid) + IPv6 (free)",
          "Configurable stateful firewall",
          "No additional traffic charges",
        ],
      },
      {
        name: "RDMA Networking",
        price: "",
        details: [
          "400 Gbps per GPU",
          "Non-blocking, low-latency network",
          "No traffic charges",
        ],
      },
      {
        name: "Private Networking",
        price: "",
        details: [
          "200 Gbps bandwidth",
          "Non-blocking, supporting any L3 protocol",
          "No traffic charges",
        ],
      },
      {
        name: "Firewall Security",
        price: "",
        details: [
          "Inbound and outbound protection",
          "Prevent unauthorized access",
          "Included with service",
        ],
      },
      {
        name: "Secure SSH Access",
        price: "",
        details: ["Fully encrypted SSH access", "Included with service"],
      },
      {
        name: "Serial Console",
        price: "",
        details: ["Monitor system operations and status", "Included with service"],
      },
    ],
    AdditionalList : [
      {
        text: "Instance snapshots",
      },
      {
        text: "Security groups",
      },
      {
        text: "High internet bandwidth",
      },
      {
        text: "Preconfigured images",
      },
      {
        text: "Public APIs, Terraform and Pulumi",
      },
    ],
  },
  reducers: {
    changeState(state, { payload }) {
      state.state = payload;
    },
  },
});
export const getters = (state) => {
  return state.Product;
};
export const { changeState } = nameSlice.actions;
export default nameSlice.reducer;
